import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonGroup,
} from "@chakra-ui/react";

const ConfirmModal = ({
  cancelButtonText,
  confirmButtonText,
  message,
  loading,
  title,
  onClose,
  onConfirm,
  isOpen,
  children,
  size,
  isDisabled,
}) => {
  const cancelRef = useRef();
  const { t } = useTranslation(["common"]);

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      size={size}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg">
            {title || t("confirm")}
          </AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            {message}
            {children}
          </AlertDialogBody>
          <AlertDialogFooter>
            <ButtonGroup spacing="3">
              <Button ref={cancelRef} onClick={onClose} variant="secondary">
                {cancelButtonText || t("no")}
              </Button>
              <Button
                variant="solid"
                onClick={onConfirm}
                isLoading={loading}
                disabled={isDisabled}
              >
                {confirmButtonText || t("yes")}
              </Button>
            </ButtonGroup>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

ConfirmModal.propTypes = {
  children: PropTypes.node,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  message: PropTypes.string,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  title: PropTypes.string,
  isDisabled: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  children: undefined,
  cancelButtonText: undefined,
  confirmButtonText: undefined,
  message: undefined,
  isOpen: undefined,
  loading: false,
  size: "md",
  title: undefined,
};

export default ConfirmModal;
